// extracted by mini-css-extract-plugin
module.exports = {"content":"GalleryPage_content__JXS3i"};